<template>
  <div class="submenu-container">
    <ul class="submenu-sections">
      <router-link
        tag="li"
        v-for="trType in menuItem"
        :to="{ name: 'BoxList', params: { boxType: trType.key } }"
        :key="trType.value"
        active-class="box-section__active--link"
      >
        <a>
          <h4>
            <span class="text">{{
              Translations.menus.sections.box.tabs['' + trType.key]
            }}</span>
          </h4>
        </a>
      </router-link>
    </ul>
    <MusicSectionMenu
      class="level-2"
      v-if="menuItemMusic.key.localeCompare(musicType) === 0"
    />
  </div>
</template>

<script>
import Constants from '@/store/constants';
import Translations from '@/store/translations';
import router from '@/router';
import MusicSectionMenu from '../Boxes/MusicSectionMenu.vue';
export default {
  name: 'BoxSectionMenu',
  components: { MusicSectionMenu },
  router,
  computed: {
    musicType: function() {
      return this.$route.params.boxType;
    },
    Translations: () => {
      return Translations;
    },
    menuItem: function() {
      const constants = Constants.trackTypes;
      return [
        constants.MUSIC,
        constants.UNDEFINED, // yes it's a playlist...
        constants.JINGLE,
        //constants.PROMO,
        // constants.VOICE_TRACK, // Remove from menu
        constants.PODCAST,
        // constants.FILLER, // Remove from menu
      ];
    },
    menuItemMusic: function() {
      return this.menuItem.filter(e => e.key.toUpperCase() === 'MUSIC')[0];
    },
  },
};
</script>

<style scoped>
.box-section__active--link {
  color: blue;
}
</style>
